export class LogMessages {
    static readonly TRIP_STARTED = 'trip has been started';
    static readonly TRIP_CLOSED = 'trip closed';
    static readonly DRIVER_ASSIGNED = 'driver assigned';
    static readonly DRIVER_CHANGED = 'driver changed';
    static readonly STEP_PLANNED_AT_CHANGED = 'step planned at changed';
    static readonly STEP_PLANNED_AT_CHANGED_CREATION = 'step planned at changed when trip was created';
    static readonly STEP_SKIPPED = 'step skipped';
    static readonly TRIP_CREATED = 'trip created';
    static readonly TRIP_FINISHED = 'trip finished';
    static readonly TRIP_SCHEDULED_START_CHANGED = 'trip scheduled start changed';
    static readonly VEHICLE_ASSIGNED = 'vehicle assigned';
    static readonly VEHICLE_CHANGED = 'vehicle changed';
    static readonly TRIP_STARTED_BY_TRIGGER = 'trip started by trigger';
    static readonly VEHICLE_STOPPED = 'vehicle stopped';
    static readonly VEHICLE_START_AGAIN = 'vehicle started to move again';
    static readonly LOCATION_CHANGED = 'location changed';
    static readonly LOCATION_MISSING_ZONES = 'location missing zones';
    static readonly DEVICE_STARTED_TO_MOVE_AGAIN = 'device started to move again';
    static readonly DEVICE_STOPPED = 'device stopped';
    static readonly CARRIER_CHANGED = 'carrier changed';
    static readonly CHECKPOINT_REORDERED = 'checkpoint reordered';
    static readonly STOPS_CALCULATED = 'stops calculated';
    static readonly CHECKPOINT_ADDED = 'checkpoint added';
    static readonly CHECKPOINT_DELETED = 'checkpoint deleted';
    static readonly TRIP_STATUS_CHANGED = 'trip status changed';
    static readonly DRIVER_NOT_FOUND = 'driver not found during trip creation';
    static readonly VEHICLE_NOT_FOUND = 'vehicle not found during trip creation';
    static readonly CARRIER_NOT_FOUND = 'carrier not found during trip creation';
    static readonly SEMITRAILER_NOT_FOUND = 'semitrailer not found during trip creation';
    static readonly MANUAL_TRIGGER = 'manual trigger';
    static readonly TRIP_REOPENED = 'trip reopened';
    static readonly TRIP_UNIT_CHANGED = 'trip unit changed';
    static readonly TRIP_UNIT_HANDED_OVER = 'trip unit handed over';
    static readonly TRIP_UNFOLDED = 'trip unfolded';
    static readonly TRIP_UNFOLDED_FROM = 'trip unfolded from';
}
